import {Component, HostListener, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {animation} from '../../../shared/animations/animations';
import {Router} from '@angular/router';
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {SurveyService} from '../surveys.service';
import {ClientModel, ExclusionCriteriaModel, SimpleSurveyQuestion, SurveyFilterUIModel, SurveyItemModel, SurveyQuestionFilterRawModel, SurveySearchPDModel} from '../../../models/survey/survey.model';
import { ToasterService } from 'angular5-toaster/dist/angular5-toaster';
import { SurveyModel } from '../../../models/people/people.model';
import { ImportFromSystemType } from '../../../shared/constants/input.constants';
import { HideQuestionModel } from '../../../models/hide-question/hide-question.model';
import { canFilterByCombined } from '../../../shared/helpers/chart-helper';
import { Observable } from 'rxjs';
import { FilterOption } from '../../../shared/constants/filter.constants';

@Component({
  selector: 'app-box-view-surveys',
  templateUrl: './box-view-version.component.html',
  styleUrls: ['./box-view-version.component.less'],
  animations: [animation]
})

export class BoxViewVersionComponent implements OnInit {

  filter = false;
  column = 'Title';
  isDesc = false;
  title: string;
  loader = false;
  showDeletePopup: boolean;
  showSyncResponsesPopup = false;
  surveySyncResponse;
  surveyForDelete;
  surveySelected: any;

  listMenu = ['Analysis', 'Question Detail', 'Sync Responses', 'Rename', 'Delete', 'Exclusion Filters'];
  listMenuWithoutSync = ['Analysis', 'Question Detail', 'Rename', 'Delete'];
  listMenuForSurveyFromCSV = ['Analysis', 'Question Detail', 'Rename', 'Delete'];

  oldTitleSurvey: string;
  isFormExclutionShow: boolean;
  listSurveyQuestionRawFilter: SurveyQuestionFilterRawModel[] = [];
  hideQuestions: HideQuestionModel[] = [];
  listSimpleSurveyQuestion: SimpleSurveyQuestion[] = [];
  listSurveyFilterUI: SurveyFilterUIModel[] = [];
  filterOption = FilterOption.AND;
  exclusionCriteraModel: ExclusionCriteriaModel;

  @Input() surveySearchPDModel: SurveySearchPDModel;
  isAdmin = AuthTokenService.isAdmin();
  isCustomerAdmin = AuthTokenService.isCustomerAdmin();

  @Output() reload = new EventEmitter<boolean>();
  showUnauthorized = false;
  unauthorizedMessage = '';
  @Input() clientSelected: ClientModel;

  constructor(private router: Router,
              private toasterService: ToasterService,
              private surveyService: SurveyService) {
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.keyCode === 27) {
      this.closeFilter();
    }
  }

  ngOnInit() {
  }

  deleteSurveyConfirm(survey) {
    this.surveyForDelete = survey;
    this.showDeletePopup = true;
  }

  deleteSurvey() {
    this.loader = true;
    this.showDeletePopup = false;
    this.surveyService.deleteSurveyFull(this.surveyForDelete.id).subscribe(res => {
      if (res) {
        this.surveySearchPDModel.listSurveyItem.splice(this.surveySearchPDModel.listSurveyItem.indexOf(this.surveyForDelete), 1);
        this.loader = false;
        this.surveyForDelete = null;
      }
    }, error => {
      this.loader = false;
    });
  }

  sort(survey) {
    this.isDesc = !this.isDesc;
    this.column = survey;
    const direction = this.isDesc ? 1 : -1;

    this.surveySearchPDModel.listSurveyItem.sort(function (a, b) {
      if (a[survey] < b[survey]) {
        return -1 * direction;
      } else if (a[survey] > b[survey]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
  }

  closeFilter() {
    this.filter = false;
  }

  navigateToSurveyAnalysis(s) {
    this.surveyService.removeSmartAnalysisResults();
    this.router.navigate(['/surveys/master-summary/' + s.id]);
  }

  navigateToSurvey(s) {
    this.router.navigate(['/surveys/new/' + s.id]);
  }

  onMenuSelect(menu: string, item) {
    switch (menu) {
      case 'Question Detail':
        this.navigateToSurvey(item);
        break;
      case 'Delete':
        this.deleteSurveyConfirm(item);
        break;
      case 'Analysis':
        this.navigateToSurveyAnalysis(item);
        break;
      case 'Rename':
        this.renameSurvey(item);
        break;
      case 'Sync Responses':
        if (item.importFromSystem !== ImportFromSystemType.CSV.toString()) {
          this.syncResponsesConfirm(item);
        }
        break;

      case 'Exclusion Filters':
        this.surveySelected = item;
        this.getDataForExclutionForm(item.id)
        break;
      default:
        break;
    }
  }

  createListMenu(item: SurveyItemModel) {
    if (item.status !== 'Pending' && item.status !== 'AwaitingApproval') {
      if (this.isAdmin || this.isCustomerAdmin) {
        if ((item.importFromSystem === ImportFromSystemType.SurveyMonKey && this.clientSelected.surveyMonkeyActivated == false) || 
            (item.importFromSystem === ImportFromSystemType.TypeForm && this.clientSelected.typeFormActivated == false)) {
            return this.listMenuWithoutSync;
        }
        return item.importFromSystem === ImportFromSystemType.CSV ? this.listMenuForSurveyFromCSV : this.listMenu;
      } else {
        return ['Question Detail', 'Analysis'];
      }
    }
    return this.isAdmin || this.isCustomerAdmin ? ['Question Detail', 'Delete'] : ['Question Detail'];
  }

  convertDateTime(input: String) {
    if (input && input.length != 10) {
      return '';
    }
    let year = input.substring(0, 4);
    let month = input.substring(5, 7);
    let date = input.substring(8, 10);
    return month + '/' + date + '/' + year;
  }

  convertThousandFormat(input: String) {
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  renameSurvey(item: any) {
    item.isRenaming = true;
    item.workspaceName = item.workspaceName ? item.workspaceName : item.title;
    this.oldTitleSurvey = item.workspaceName;
    setTimeout(_ => {
      const element = document.getElementById('renameInput' + item.id);
      element.focus();
    }, 50);
  }

  onClickSurveyTile(event: any, survey: any) {
    var origin = event.srcElement || event.target;
    if (origin.tagName && origin.tagName.match(/input/i)) {
      return;
    } else {
      this.navigateToSurveyAnalysis(survey);
    }
  }

  keyPress(key: string, survey: any) {
    switch (key) {
      case 'enter':
      case 'tab':
        survey.isRenaming = false;
        if (survey.workspaceName) {
          this.oldTitleSurvey = null;
          this.surveyService.updateWorkspaceName({id: survey.id, workspaceName: survey.workspaceName}).subscribe(_ => {
          }, _ => {
          });
        }
        break;
      case 'esc':
        survey.isRenaming = false;
        survey.workspaceName = this.oldTitleSurvey ? this.oldTitleSurvey : survey.workspaceName;
        break;
      default:
        break;
    }
  }

  syncResponsesConfirm(survey) {
    this.showSyncResponsesPopup = true;
    this.surveySyncResponse = survey;
  }

  getSyncSurveyName() {
    return this.surveySyncResponse ? this.surveySyncResponse.workspaceName ? this.surveySyncResponse.workspaceName : this.surveySyncResponse.title : '';
  }

  syncResponses() {
    this.loader = true;
    this.showSyncResponsesPopup = false;
    this.surveyService.syncResponse(this.surveySyncResponse.id).subscribe(res => {
      this.loader = false;
      if (res.success) {
        this.toasterService.pop('success', 'Success', 'Sync Responses successed');
        this.reload.emit(true);
      } else if (res.unauthorized) {
        if (this.surveySyncResponse.importFromSystem === ImportFromSystemType.TypeForm) {
            this.unauthorizedMessage = 'Could not connect to TypeForm. Invalid API Token';
        } else {
            this.unauthorizedMessage = 'Could not connect to SurveyMonkey. Invalid API Token';
        }
        this.showUnauthorized = true;
      } else {
        this.toasterService.pop('error', 'Error', res.messages[0].message);
      }
    }, error => {
      this.loader = false;
      this.toasterService.pop('error', 'Error', 'Error');
    });
  }

  reSyncResponses(surveyId: number) {
    this.loader = true;
    this.surveyService.reSyncResponse(surveyId).subscribe(res => {
      this.loader = false;
      if (res.success) {
        this.toasterService.pop('success', 'Success', 'Sync Responses successed');
        this.reload.emit(true);
      } else if (res.unauthorized) {
        if (this.surveySelected.importFromSystem === ImportFromSystemType.TypeForm) {
            this.unauthorizedMessage = 'Could not connect to TypeForm. Invalid API Token';
        } else {
            this.unauthorizedMessage = 'Could not connect to SurveyMonkey. Invalid API Token';
        }
        this.showUnauthorized = true;
      } else {
        this.toasterService.pop('error', 'Error', res.messages[0].message);
      }
    }, error => {
      this.loader = false;
      this.toasterService.pop('error', 'Error', 'Error');
    });
  }

  getDataForExclutionForm(surveyId: number){
    Observable.combineLatest(
      this.surveyService.getHideQuestion(surveyId),
      this.surveyService.getListSurveyQuestionFilter(surveyId),
      this.surveyService.getExclusionCriteriaBySurvey(surveyId)
    ).subscribe(
        response => {
          this.hideQuestions = response[0];
          this.hideQuestions = this.hideQuestions.sort((a, b) => a.questionId < b.questionId ? -1 : 1);
          this.listSurveyQuestionRawFilter = response[1];
          this.getListSimpleSurveyQuestion();

          if (response[2]) {
            this.exclusionCriteraModel = response[2] as ExclusionCriteriaModel;
            this.listSurveyFilterUI = this.exclusionCriteraModel.criteriaJson;
            this.filterOption = this.exclusionCriteraModel.isOrOperator;
          } else if (this.listSurveyFilterUI.length === 0) {
            this.listSurveyFilterUI.push(new SurveyFilterUIModel());
          }
          this.isFormExclutionShow= true;

          },
        err => console.error(err)
    );
  }

  getListSimpleSurveyQuestion() {
    this.listSimpleSurveyQuestion = [];
    this.listSurveyQuestionRawFilter.forEach(s => {
      if (canFilterByCombined(s.answerType) && !this.isHideQuestion(s.id)) {
        this.listSimpleSurveyQuestion.push(new SimpleSurveyQuestion(s.id, s.question));
      }
    });
  }

  isHideQuestion(questionId: number) {
    return this.hideQuestions.map(x => x.questionId).includes(questionId);
  }


  onQuestionFilterFinished(filter) {
    const listSurveyFilterUI = filter.listSurveyFilterUI ? filter.listSurveyFilterUI.filter(s => s.isChecked && s.question) : [];
    let exclusionCriteria = new ExclusionCriteriaModel();
    exclusionCriteria.criteriaJson = listSurveyFilterUI;
    exclusionCriteria.isOrOperator = filter.isOrOperator;
    exclusionCriteria.surveyId = this.surveySelected.id;
    let actionApi = new Observable<any>();

    if (this.exclusionCriteraModel && this.exclusionCriteraModel.id > 0) {
      exclusionCriteria.id =   this.exclusionCriteraModel.id;
      actionApi = this.surveyService.updateExclusionCriteria(exclusionCriteria);
    } else {
      actionApi = this.surveyService.saveExclusionCriteria(exclusionCriteria);
    }
    actionApi.subscribe(()=>{
      this.isFormExclutionShow = false;
      this.reSyncResponses(this.surveySelected.id);
    });
  }

  onQuestionFilterCancelled(listSurveyFilterUI) {
    setTimeout(() => {
      this.listSurveyFilterUI = [];
      this.surveySelected = null;
      this.listSimpleSurveyQuestion= [];
      this.exclusionCriteraModel= null;
      this.listSurveyQuestionRawFilter= [];
      this.hideQuestions= [];
    }, );
    this.isFormExclutionShow= false;

  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/box-view-version/box-view-version.component.ts